module.exports = __webpack_public_path__ + "static/media/loginbackground.a766863f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/loginbackground.jpg
// module id = 1334
// module chunks = 0